import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import * as React from "react";
import {Button} from "@mui/material";
import {MouseEventHandler} from "react";


interface FormWrapperProps {
    title: string;
    note: string;
    closeHandler: MouseEventHandler<HTMLButtonElement>;
    titleVariant?: "button" | "caption" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "inherit" | "overline" | "subtitle1" | "subtitle2" | "body1" | "body2";
    topPadding?: number;
    sx?: any;
}

export default (props: FormWrapperProps) => {
    const topPadding = props.topPadding !== undefined ? props.topPadding : 16;
    return (
        <Paper sx={{marginTop: topPadding, ...props.sx}}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: '350px',
                    maxWidth: '450px',
                    p: 3
                }}
            >
                <Box sx={{textAlign: "left", width: "100%"}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography component="h5" variant={props.titleVariant ? props.titleVariant : 'h5'}>
                                {props.title}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{mt: 1, width: '100%'}}>
                    <p>
                        {props.note}
                    </p>
                     <Button
                        variant="contained"
                        sx={{mt: 3, float: ' right'}}
                        onClick={props.closeHandler}
                    >
                        Close
                    </Button>
                </Box>
            </Box>
        </Paper>
    )
}